<div class="main-container">
  @if (showPopup) {
    <div class="popup-container">
      <div class="popup">
        <div class="close" (click)="closePopup()">
          <mat-icon svgIcon="cross"></mat-icon>
        </div>
        <div class="popup-inner">
          <div class="tabs">
            <div class="tab universes" [ngClass]="activeTab === 'universes' ? 'active' : null"
            (click)="switchTab('universes')">{{ 'gamification.avatar.universe' | translate }}</div>
            @for (position of badgesPosition; track position) {
              <div class="tab accessories"
                [ngClass]="activeTab === position.name ? 'active' : null"
              (click)="switchTab(position.name)">{{ position.name | translate }}</div>
            }
          </div>
          <div class="items-container">
            @for (position of badgesPosition; track position) {
              @if (activeTab === position.name) {
                <div class="items accessories inner-scroll" fusePerfectScrollbar
                  >
                  @for (accessory of getAccessoriesPerPosition(position.id); track accessory) {
                    <app-accessory-thumbnail class="item"
                      [badge]="accessory.attributes"
                    (click)="onAccessoryClick(accessory)"></app-accessory-thumbnail>
                  }
                </div>
              }
            }
            @if (activeTab === 'universes') {
              <div class="items universes inner-scroll" fusePerfectScrollbar>
                @for (universe of universes; track universe) {
                  <app-accessory-thumbnail class="item"
                    [badge]="universe.attributes"
                  (click)="onUniverseClick(universe)"></app-accessory-thumbnail>
                }
              </div>
            }
          </div>
          <div class="buttons">
            <div class="button">
              <!-- TODO pas de disabled sur une div, soit passer sur un bouton par exemple ou sur data-disabled -->
              <div class="inner-button save"
                [ngClass]="isSaveButtonActive ? 'enabled' : null"
                [disabled]="!isSaveButtonActive"
                (click)="save()">
                {{ 'generic.register' | translate }}
              </div>
            </div>
            <div class="button">
              <!-- TODO pas de disabled sur une div, soit passer sur un bouton par exemple ou sur data-disabled -->
              <div class="inner-button reset"
                [ngClass]="isResetButtonActive ? 'enabled' : null"
                [disabled]="!isResetButtonActive"
                (click)="reset()">
              {{ 'generic.reset' | translate }}</div>
            </div>
          </div>
          @if (isLoading === true) {
            <div class="loading">
              <mat-spinner></mat-spinner>
            </div>
          }
        </div>
      </div>
    </div>
  }


  @if (!showPopup) {
    <div class="controls customize-container" title="{{ 'gamification.avatar.edit' | translate }}">
      <div class="control customize" (click)="openPopup()">
        <mat-icon svgIcon="accessorize"></mat-icon>
      </div>
    </div>
  }
</div>